import type { NavigationPath } from '../../routes/navigation';

export type RouteLabelHook = () => string;
export type BreadcrumbPath = NavigationPath | `/tests/e2e/plans/${string}`;
export type RouteBreadcrumbPathHook = () => BreadcrumbPath | undefined;

export interface RouteBreadcrumb {
  useLabel: RouteLabelHook;
  to?: BreadcrumbPath;
  useTo?: RouteBreadcrumbPathHook;
}

export interface RouteLabelHooks {
  useBreadcrumbLabel: RouteLabelHook;
  useDocumentTitlePrefix: RouteLabelHook;
}

export const routeLabels = (label: string): RouteLabelHooks => ({
  useBreadcrumbLabel: () => label,
  useDocumentTitlePrefix: () => label,
});

export const getDocumentTitle = (pageName: string) => `${pageName} - MP Dev Platform`;
